module.exports = __webpack_public_path__ + "img/partner14.d9574836.png";